<template>
  <page-table />
</template>
<script>
import PageTable from './components/order-table'
export default {
  name: 'order-customerOrder',
  components: {
    PageTable,
  },
}
</script>